import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { apiService } from '../services/api'

export default function OAuthCallback({ onLoginSuccess }) {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState(null)
  const [processing, setProcessing] = useState(true)

  useEffect(() => {
    const handleCallback = async () => {
      try {
        const code = searchParams.get('code')
        const state = searchParams.get('state')
        const errorParam = searchParams.get('error')

        // Check for OAuth errors from provider
        if (errorParam) {
          setError(`Błąd uwierzytelniania: ${errorParam}`)
          setProcessing(false)
          return
        }

        // Validate we have required parameters
        if (!code || !state) {
          setError('Brak wymaganych parametrów uwierzytelniania')
          setProcessing(false)
          return
        }

        // Send code and state to backend
        const response = await apiService.googleCallback(code, state)
        const { access_token, user } = response.data

        // Save token and user info
        localStorage.setItem('auth_token', access_token)
        localStorage.setItem('user', JSON.stringify(user))

        // Call success callback
        onLoginSuccess(user)

        // Restore the URL the user was on before we sent them to Google.
        // Set by Login.jsx for any non-trivial path (e.g. /mcp/connect?return_to=…).
        // Use full reload so the URL is observed by the freshly-mounted Router
        // in App.jsx authenticated branch (and by McpConnectPage which then
        // reads ?return_to and bounces to /mcp/oauth/authorize).
        const saved = sessionStorage.getItem('post_login_redirect')
        if (saved) {
          sessionStorage.removeItem('post_login_redirect')
          window.location.replace(saved)
          return
        }

        // Default — go to dashboard
        navigate('/dashboard')
      } catch (err) {
        console.error('OAuth callback error:', err)
        const errorMessage = err.response?.data?.detail || 'Wystąpił błąd podczas uwierzytelniania'
        setError(errorMessage)
        setProcessing(false)
      }
    }

    handleCallback()
  }, [searchParams, onLoginSuccess])

  if (processing) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="bg-white rounded-xl shadow-xl p-8 max-w-md w-full mx-4">
          <div className="text-center">
            <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mb-4"></div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Uwierzytelnianie...
            </h2>
            <p className="text-gray-600">
              Trwa logowanie przez Google Workspace
            </p>
          </div>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="bg-white rounded-xl shadow-xl p-8 max-w-md w-full mx-4">
          <div className="text-center">
            {/* Error Icon */}
            <div className="inline-flex items-center justify-center w-16 h-16 bg-red-100 rounded-full mb-4">
              <svg 
                className="w-8 h-8 text-red-600" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M6 18L18 6M6 6l12 12" 
                />
              </svg>
            </div>
            
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Błąd uwierzytelniania
            </h2>
            
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
              <p className="text-sm">{error}</p>
            </div>
            
            <button
              onClick={() => window.location.href = '/'}
              className="w-full py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
            >
              Powrót do logowania
            </button>
          </div>
        </div>
      </div>
    )
  }

  return null
}


